import {getBizInfo} from '@/request'
import getMItem from './getMItem'
import setMItem from './setMItem'
import getValidToken from './getValidToken'
export default async function changeBtoken(ticket: string, newToken?: string) {
    const res = await getBizInfo({
        ticket
    })
    const bizId = res.data?.id
    localStorage.setItem('ticket', ticket)
    const newBtoken = getValidToken(newToken ||  getMItem(bizId) || '')
    console.log('获取到的newBtoken', newBtoken)
    setMItem(bizId, newBtoken)
    localStorage.setItem('btoken', newBtoken)
    return newBtoken
}
